import * as React from "react"
import { router } from "@inertiajs/react"
import {
  Dialog, DialogTrigger, DialogContent, DialogHeader, DialogFooter, DialogTitle, DialogClose,
} from "@/components/ui/Dialog"
import { Button } from "@/components/ui/Button"

type Props = { requestId: string; userName: string }

// Rejecting an access request: optional reason, notifies the user. Approval is
// the separate "assign a role" action, so this dialog only handles the decline.
export default function RejectRequestDialog({ requestId, userName }: Props) {
  const [open, setOpen] = React.useState(false)
  const [note, setNote] = React.useState("")
  const [submitting, setSubmitting] = React.useState(false)

  const submit = () => {
    setSubmitting(true)
    router.post(
      `/team/onboarding_requests/${requestId}/reject`,
      { review_note: note },
      {
        onFinish: () => {
          setSubmitting(false)
          setOpen(false)
          setNote("")
        },
      }
    )
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="ghost" size="sm" className="text-xs text-destructive">Reject</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Reject {userName}'s request?</DialogTitle>
        </DialogHeader>

        <div className="flex flex-col gap-1">
          <label className="text-sm">Reason (optional — shared with the user)</label>
          <textarea
            value={note}
            onChange={(e) => setNote(e.target.value)}
            rows={3}
            className="rounded-md border border-input bg-transparent px-3 py-2 text-sm"
          />
        </div>

        <DialogFooter>
          <DialogClose asChild><Button variant="ghost">Cancel</Button></DialogClose>
          <Button variant="destructive" disabled={submitting} onClick={submit}>Reject request</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
